import type { MouseEvent } from 'react';

import { type AuditLogEntry, describeAuditTime, useAuditText } from '@/domain/auditLog';

import styles from './TimeCell.module.scss';

interface TimeCellProps {
    entry: AuditLogEntry;
    onSelect: (entry: AuditLogEntry) => void;
}

/**
 * The one control in a row that the keyboard reaches: the row's own click is a mouse
 * shortcut, and a real button gives keyboard and screen reader users the details too.
 */
export default function TimeCell({ entry, onSelect }: TimeCellProps) {
    const render = useAuditText();
    const time = describeAuditTime(entry.occurredAt);

    function handleClick(event: MouseEvent<HTMLButtonElement>) {
        // The row would open the details a second time.
        event.stopPropagation();
        onSelect(entry);
    }

    return (
        <button
            type="button"
            className={styles.timeButton}
            title={render(time.title)}
            onClick={handleClick}>
            <span className={styles.time}>{time.time}</span>
            <span className={styles.date}>{time.date}</span>
        </button>
    );
}
